<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'ORDERS', pageCode: 'ALL', subPageCode: 'ADD' }">

    <p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="tab-icons">
                    <i class="mi-lg" [class]="miIcons.DETAILS"></i>
                    <span translate>order.lbl_details</span>
                </div>
            </ng-template>
            <form #orderForm="ngForm" class="order-form">
                <div class="col-12 md:col-12 tab-group">
                    <div class="card p-fluid ml-2 mr-2 mt-2">
                        <div class="p-fluid p-formgrid  w-full formgrid grid">
                            <div class="protocol-section  field input-field-wrapper col-12 md:col-12  lg:col-12">
                                <label class="protocol-label" translate>order.lbl_protocol<span
                                        class="required">*</span></label>
                                <p-autoComplete
                                    name="protocol"
                                    [(ngModel)]="selectedItem"
                                    [dropdown]="true"
                                    [suggestions]="filteredItems"
                                    (completeMethod)="filterItems($event)"
                                    (onSelect)="onSelectItem()"
                                    optionLabel="name"
                                    [placeholder]="'order.lbl_search' | translate" />
                            </div>
                        </div>
                    </div>
                </div>

                @if(!isAllowToPlaceOrder) {
                <div class="mb-4">
                    <p-message severity="warn"
                        [text]="'You do not have permission to add an order for the selected protocol.'"
                        [closable]="false" styleClass="w-full">
                    </p-message>
                </div>
                }

                @if(products.length > 0) {

                <div class=" tab-group ml-2 mr-4 mt-2">
                    <div class="card p-fluid ml-2 mr-2 w-full">
                        <div class="product-section">
                            <div class="product-header w-full formgrid grid pt-3 font-semibold text-lg">
                                <div class=" field input-field-wrapper col-12 md:col-12"
                                    [ngClass]="isPatientManagmentOn ? 'lg:col-6' : 'lg:col-9'">
                                    <span translate>product.lbl_product</span>
                                </div>
                                <div class=" field input-field-wrapper col-12 md:col-12  lg:col-3 uppercase">
                                    <span translate class="uppercase">order.lbl_qty</span>
                                </div>
                                @if(isPatientManagmentOn) {
                                <div class=" field input-field-wrapper col-12 md:col-12  lg:col-3 uppercase">
                                    <span translate>order.lbl_select_patient</span>
                                </div>
                                }
                            </div>
                            <div class="product-body">
                                @for (product of products; track product.id) {
                                <div class="w-full formgrid grid pt-3 border-bottom-1 hr-border">
                                    <div class=" field input-field-wrapper col-12 md:col-12"
                                        [ngClass]="isPatientManagmentOn ? 'lg:col-6' : 'lg:col-9'">
                                        <span class="product-name">{{product.product_name}}</span>
                                    </div>
                                    <div class="oduct-row field input-field-wrapper col-12 md:col-12  lg:col-3">
                                        <input pInputText type="text" [value]="product.qty || ''" class="qty-input"
                                            [class.error-input]="quantityErrors[$index]"
                                            maxlength="6"
                                            (keypress)="onQuantityKeyPress($event)"
                                            (input)="onQuantityInput($event, $index)"
                                            (blur)="clearQuantityError($index)"
                                            placeholder="Enter quantity" />
                                        @if(quantityErrors[$index]) {
                                        <div class="error-message">{{quantityErrors[$index]}}</div>
                                        }
                                    </div>
                                    @if(isPatientManagmentOn) {
                                    <div class="field input-field-wrapper col-12 md:col-12  lg:col-3">
                                        <p-button
                                            [label]="(product.selectedPatients?.length || 0) + ' ' + ('order.lbl_selected' | translate)"
                                            icon="pi pi-arrow-right"
                                            styleClass="select-patient-btn"
                                            [outlined]="true"
                                            (onClick)="openPatientDialog($index)" />
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
                } @else if(selectedItem && products.length === 0) {
                <div class=" tab-group ml-2 mr-4 mt-2">
                    <div class="card p-fluid ml-2 mr-2 w-full">
                        <div class="product-section">
                            <div class="product-header w-full formgrid grid pt-3 ">
                                <div
                                    class=" field input-field-wrapper col-12 md:col-12  lg:col-6  default-text-light-black-color">
                                    <span translate>order.lbl_no_products_found</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }@else if(!selectedItem ) {
                <div class=" tab-group ml-2 mr-4 mt-2">
                    <div class="card p-fluid ml-2 mr-2 w-full">
                        <div class="product-section">
                            <div class="product-header w-full formgrid grid pt-3 ">
                                <div
                                    class=" field input-field-wrapper col-12 md:col-12  lg:col-6 default-text-light-black-color">
                                    <span translate>order.lbl_please_select_protocol</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div class="place-order-btn-section flex justify-content-end mt-4 mr-4 mb-4">
                    <button pButton class="place-order-btn" [disabled]="!isAllowToPlaceOrder" (click)="placeOrder()"
                        translate>order.lbl_place_order</button>
                </div>
                <div class="flex justify-content-end flex-wrap btn-with-links">
                    <button pButton class="mr-2 bg-white default-text-light-black-color cursor-pointer border-button"
                        [label]="'cancel' | translate" (click)="onCancel()"></button>
                    <p-button class="flex align-items-center justify-content-center cursor-pointer passenger-box"
                        [label]="'order.lbl_place_order' | translate" (onClick)="placeOrder()"
                        [disabled]="!isAllowToPlaceOrder"></p-button>
                </div>
            </form>
        </p-tabPanel>
    </p-tabView>

    @if(isPatientManagmentOn) {
    <app-patient-selection-dialog
        [(visible)]="showPatientDialog"
        [protocolEntityId]="protocolEntityId"
        [productIndex]="selectedProductIndex"
        [selectedPatients]="selectedPatientsForDialog"
        (onSaveSelection)="onPatientSelectionSave($event)">
    </app-patient-selection-dialog>
    }


    @if(showConfirmDialog) {
    <div class="confirmation-dialog">
        <p-dialog header="Confirm Order Submission" [(visible)]="showConfirmDialog"
            [style]="{minWidth: '600px', maxWidth: '60vw'}"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            class="patient-selection-dialog">
            <div class="confirm-dialog">
                <div class="protocol-section font-bold text-lg">
                    {{ 'order.lbl_confirm_order_header' | translate }}
                </div>
                <div class="protocol-section border-400 border-round-md border-1 p-3">
                    <div class="protocol-label font-bold" translate>lbl_protocol_name</div>
                    <div class="protocol-value">{{ selectedItem?.name}}</div>
                </div>
                <table class="product-table border-400 border-round-md border-1">
                    <thead class="bg-white">
                        <tr>
                            <th class="uppercase" translate>order.lbl_product</th>
                            <th class="uppercase" translate>order.lbl_qty</th>
                            @if(isPatientManagmentOn) {
                            <th class="uppercase" translate>order.lbl_selected_patient</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (product of confirmProducts; track product.id) {
                        <tr>
                            <td>{{ product.product_name }}</td>
                            <td class="text-left">{{ product.qty }}</td>
                            @if(isPatientManagmentOn) {
                            <td>
                                <div class="patient-list">
                                    @for (patient of product.selectedPatients; track patient.id; let i = $index) {
                                    <span
                                        class="patient-id"
                                        [pTooltip]="patient.name || patient.id"
                                        tooltipPosition="top">
                                        {{ i + 1 }}. {{ patient.name || patient.id }}
                                    </span>
                                    }
                                </div>
                            </td>
                            }
                        </tr>
                        }
                        <tr class="total-row">
                            <td class="font-bold" translate>order.lbl_total</td>
                            <td class="font-bold text-left">{{ getTotalQuantity() }}</td>
                            @if(isPatientManagmentOn) {
                            <td></td>
                            }
                        </tr>
                    </tbody>
                </table>
                <div class="info-text">
                    This order is now with the Akesa team for fulfilment. If you have any immediate issues, please
                    contact
                    support
                    at <span class="support-number">+61 3 7064 9629</span>
                </div>
                <div class="actions">
                    <button pButton type="button" (click)="onConfirmCancel()">Cancel</button>
                    <button pButton type="button" class="confirm-btn" (click)="onConfirmOrder()">Confirm</button>
                </div>
            </div>
        </p-dialog>
    </div>
    }
</div>